import { render, staticRenderFns } from "./NewCategoryProperty.vue?vue&type=template&id=018099ea&scoped=true&"
import script from "./NewCategoryProperty.vue?vue&type=script&lang=js&"
export * from "./NewCategoryProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018099ea",
  null
  
)

export default component.exports